import { getReceiptDisplayNumber } from '../InvoiceForm/invoiceNumber.utils'
import { parseBalance } from '../InvoiceForm/paymentForm.utils'
import NumberFormat from '../../utils/number.format'

export class ReceiptsAdapter {
	static responseToListRow(row = {}) {
		const balanceDue = parseBalance(row.balance_due ?? row.balance ?? row.Balance)
		const paidAmount = parseBalance(row.paid_amount ?? row.paidAmount)
		return {
			...row,
			id: row.id,
			receipt_number: row.receipt_number,
			receipt_nro: row.receipt_nro,
			displayNumber: getReceiptDisplayNumber({
				receipt_number: row.receipt_number,
				receipt_nro: row.receipt_nro,
				id: row.id,
			}),
			date_receipt: row.date_receipt || '',
			date_due: row.date_due || '',
			type: row.type || 'Receipt',
			status: row.status || '',
			company_id: row.company_id,
			notes: row.notes || '',
			reference_name: row.reference_name,
			total: row.total,
			totalFormatted:
				typeof row.total === 'string'
					? row.total
					: NumberFormat.currency(Number(row.total) || 0),
			balance_due: row.balance_due ?? balanceDue,
			balanceDue,
			Balance: row.Balance ?? row.balance ?? NumberFormat.currency(balanceDue),
			client_id: row.client_id,
			client: row.client,
			discount_total: row.discount_total ?? 0,
			discount_percentage: row.discount_percentage ?? 0,
			deposit: row.deposit,
			message: row.message,
			client_send_email: row.client_send_email,
			payments: row.payments || [],
			total_payments: row.total_payments ?? 0,
			paid_amount: row.paid_amount ?? paidAmount,
			paidAmount,
			tax_por: row.tax_por,
			tax_amount: row.tax_amount,
			type_discount: row.type_discount,
			pay_term_id: row.pay_term_id,
			tax_exempt: row.tax_exempt,
			pay_terms: row.pay_terms || [],
			details: row.details || [],
			refounds: row.refounds || [],
			total_taxable: row.total_taxable,
			created_user: row.created_user,
		}
	}

	static responseToList(data = []) {
		return (data || []).map(ReceiptsAdapter.responseToListRow)
	}
}
